import {create} from 'zustand'
import {persist} from 'zustand/middleware'

export type PendingToast = {
    id: string;
    title: string;
    description: string;
    variant: 'default' | 'destructive';
    duration?: number;
}

interface UserSettings {
    tableSettings: {
        pageSize: number
        orderTimesSortBy?: string
        orderTimesSortOrder?: 'asc' | 'desc'
    },
    pendingToasts: PendingToast[],
    setPageSize: (size: number) => void
    setOrderTimesSorting: (sortBy: string, sortOrder: 'asc' | 'desc') => void
    addPendingToast: (toast: Omit<PendingToast, 'id'>) => void
    consumePendingToasts: () => PendingToast[]
}

export const useUserSettingsStore = create<UserSettings>()(
    persist(
        (set, get) => ({
            tableSettings: {
                pageSize: 10,
            },
            pendingToasts: [],
            setPageSize: (size: number) => set((state) => ({
                tableSettings: {
                    ...state.tableSettings,
                    pageSize: size
                }
            })),
            setOrderTimesSorting: (sortBy: string, sortOrder: 'asc' | 'desc') => set((state) => ({
                tableSettings: {
                    ...state.tableSettings,
                    orderTimesSortBy: sortBy,
                    orderTimesSortOrder: sortOrder
                }
            })),
            addPendingToast: (toast: Omit<PendingToast, 'id'>) => set((state) => ({
                pendingToasts: [
                    ...state.pendingToasts,
                    {
                        ...toast,
                        id: `toast-${Date.now()}-${Math.random()}`
                    }
                ]
            })),
            consumePendingToasts: () => {
                const toasts = get().pendingToasts;
                set({ pendingToasts: [] }); // Clear after reading
                return toasts;
            }
        }),
        {
            name: 'user-settings',
            partialize: (state) => ({
                // Only persist table settings, not pending toasts
                tableSettings: state.tableSettings
            })
        }
    )
)
